export default __webpack_public_path__ + "static/media/2113.c31270f1.png";